import { Specification } from '../../types/response'
import { GridInformation } from 'vnetwork-ui'
import { Badge } from '@/components/ui/badge'

interface ModelSpecificationsProps {
    specifications: Specification[]
}

const ModelSpecifications = ({ specifications }: ModelSpecificationsProps) => {
    if (!specifications || specifications.length === 0) {
        return (
            <GridInformation
                data={[
                    {
                        label: '',
                        value: 'No specifications defined for this model.',
                        className: 'lg:col-span-4 text-center text-gray-500',
                    },
                ]}
                head={{
                    title: 'Specifications (0)',
                }}
            />
        )
    }

    // Sort by display_order
    const sortedSpecs = [...specifications].sort(
        (a, b) => a.display_order - b.display_order
    )

    const specData = sortedSpecs.map((spec) => ({
        label: spec.name,
        value: (
            <div className="flex items-center gap-2">
                <span>{spec.value}</span>
                {spec.unit && (
                    <span className="text-gray-500">({spec.unit})</span>
                )}
                {spec.is_primary && (
                    <Badge variant="outline" className="ml-2">
                        Primary
                    </Badge>
                )}
            </div>
        ),
    }))

    return (
        <GridInformation
            data={specData}
            head={{
                title: `Specifications (${specifications.length})`,
            }}
        />
    )
}

export default ModelSpecifications
